<template>
    <div class="footer">
        <div class="footer-l">
            <div class="img-box">
                <img src="../assets/elm.png" alt="">
                <div class="img-text">
                    <div>E-mail</div>
                    <p>news@truongnguyenthinhphat.com</p>
                </div>
            </div>
            <div class="img-box">
                <img src="../assets/tel.png" alt="">
                <div class="img-text">
                    <div>Điện thoại</div>
                    <p>+84 845767690</p>
                </div>
            </div>
        </div>
        <div class="footer-r">
            <div class="item-box">
                <div>Giờ kinh doanh</div>
                <p>Monday to Friday: 9:30 am - 6 pm <br>
                    Saturday: 10 am - 4 pm</p>
            </div>
            <div class="item-box">
                <div>studio của chúng tôi</div>
                <p>243/6 Phan Văn Hớn, Phường Tân Thới Nhất, Quận 12 TPHCM</p>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'App',
    data() {
        return {
            value: ''
        }
    },
    mounted() {

    },
    methods: {
        sendEmail() {
            if (!this.value) {
                return alert('Email cannot be empty')
            }
            return alert('Sent successfully')
        }
    }
}
</script>


<style lang="less" scoped>
.footer {
    background: #0E235F;
    padding: 80px 360px;
    display: flex;
    align-items: center;
    justify-content: space-between;

    .footer-l {
        .img-box {
            display: flex;
            align-items: center;
            padding: 20px 0px;

            img {
                width: 60px;
                margin-right: 10px;
            }

            .img-text {
                div {
                    font-size: 16px;
                    color: #FFFFFF;
                }

                p {
                    font-weight: bold;
                    font-size: 22px;
                    color: #FFFFFF;
                }
            }
        }
    }

    .footer-r {
        width: 539px;

        .item-box {
            padding: 20px 0px;

            div {
                font-weight: bold;
                font-size: 22px;
                color: #FFFFFF;
            }

            p {
                font-size: 16px;
                color: #FFFFFF;
                margin-top: 20px;
            }
        }
    }
}
</style>